@if (visible()) {
  <!-- Quantidade por página à esquerda, navegação entre páginas à direita (mesmo layout da paginação de Planos). -->
  <footer class="pagination" data-testid="pagination">
    <div class="pagination__size" role="group" aria-label="Itens por página" data-testid="pagination-size">
      <span>Mostrar</span>
      @for (size of pageSizeOptions(); track size; let last = $last) {
        <button
          type="button"
          class="pagination__size-option"
          [class.pagination__size-option--current]="size === pageSize()"
          [attr.aria-pressed]="size === pageSize()"
          [attr.data-testid]="'pagination-size-' + size"
          (click)="changePageSize(size)"
        >
          {{ size }}
        </button>
        @if (!last) {
          <span class="pagination__size-divider" aria-hidden="true">|</span>
        }
      }
      <span>Itens por página</span>
    </div>

    <nav class="pagination__nav" aria-label="Paginação">
      <button
        type="button"
        class="pagination__page"
        aria-label="Primeira página"
        [disabled]="!canGoPrevious()"
        data-testid="pagination-first"
        (click)="goToPage(1)"
      >
        <vivest-icon name="chevrons-left" source="feather" aria-hidden="true"></vivest-icon>
      </button>
      <button
        type="button"
        class="pagination__page"
        aria-label="Página anterior"
        [disabled]="!canGoPrevious()"
        data-testid="pagination-prev"
        (click)="goToPage(currentPage() - 1)"
      >
        <vivest-icon name="chevron-left" source="feather" aria-hidden="true"></vivest-icon>
      </button>
      @for (page of pages(); track page) {
        <button
          type="button"
          class="pagination__page"
          [class.pagination__page--current]="page === currentPage()"
          [attr.aria-current]="page === currentPage() ? 'page' : null"
          [attr.aria-label]="'Página ' + page"
          [attr.data-testid]="'pagination-page-' + page"
          (click)="goToPage(page)"
        >
          {{ page }}
        </button>
      }
      <button
        type="button"
        class="pagination__page"
        aria-label="Próxima página"
        [disabled]="!canGoNext()"
        data-testid="pagination-next"
        (click)="goToPage(currentPage() + 1)"
      >
        <vivest-icon name="chevron-right" source="feather" aria-hidden="true"></vivest-icon>
      </button>
      <button
        type="button"
        class="pagination__page"
        aria-label="Última página"
        [disabled]="!canGoNext()"
        data-testid="pagination-last"
        (click)="goToPage(totalPages())"
      >
        <vivest-icon name="chevrons-right" source="feather" aria-hidden="true"></vivest-icon>
      </button>
    </nav>
  </footer>
}
